import React, { useEffect } from 'react';

const KEYFRAMES = `
@keyframes fwConfetti {
  0% { transform: translateY(-10px) rotate(0deg); opacity: 1; }
  100% { transform: translateY(105vh) rotate(720deg); opacity: 0; }
}
@keyframes fwFadeIn {
  from { opacity: 0; transform: scale(0.85); }
  to { opacity: 1; transform: scale(1); }
}
@keyframes fwTitleReveal {
  0% { opacity: 0; transform: translateY(30px); }
  100% { opacity: 1; transform: translateY(0); }
}
@keyframes fwNameReveal {
  0% { opacity: 0; transform: scale(0.5); }
  60% { transform: scale(1.15); }
  100% { opacity: 1; transform: scale(1); }
}
@keyframes fwGoldPulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(212,175,55,0); }
  50% { box-shadow: 0 0 40px 12px rgba(212,175,55,0.5); }
}
@keyframes fwTrophySpin {
  0% { transform: rotate(-15deg) scale(0.8); opacity: 0; }
  60% { transform: rotate(10deg) scale(1.2); }
  100% { transform: rotate(0deg) scale(1); opacity: 1; }
}
`;

const CONFETTI_COLORS = ['#d4af37', '#ffffff', '#10b981', '#f59e0b', '#ef4444', '#6366f1', '#ec4899', '#06b6d4'];

function Confetti() {
  const pieces = Array.from({ length: 26 }, (_, i) => ({
    left: `${(i * 3.9 + 1) % 100}%`,
    width: `${8 + (i % 6) * 3}px`,
    height: `${8 + (i % 6) * 3}px`,
    bg: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
    delay: `${(i * 0.12) % 2.5}s`,
    duration: `${2.4 + (i % 4) * 0.4}s`,
    radius: i % 3 === 0 ? '50%' : i % 3 === 1 ? '2px' : '0%',
  }));

  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 3100, overflow: 'hidden' }}>
      {pieces.map((p, i) => (
        <div key={i} style={{
          position: 'absolute',
          top: '-20px',
          left: p.left,
          width: p.width,
          height: p.height,
          backgroundColor: p.bg,
          borderRadius: p.radius,
          animation: `fwConfetti ${p.duration} ${p.delay} ease-in forwards`,
        }} />
      ))}
    </div>
  );
}

function FinaleWinnerPopup({ data, onClose }) {
  useEffect(() => {
    const el = document.createElement('style');
    el.textContent = KEYFRAMES;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0,0,0,0.97)',
      zIndex: 3000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      overflowY: 'auto',
    }}>
      <Confetti />

      <div style={{
        maxWidth: '480px',
        width: '100%',
        animation: 'fwFadeIn 0.6s ease both',
      }}>
        <span style={{
          fontSize: '80px',
          animation: 'fwTrophySpin 0.8s 0.3s ease both',
          display: 'block',
          textAlign: 'center',
          marginBottom: '16px',
        }}>
          🏆
        </span>

        <div style={{
          fontSize: '14px',
          fontWeight: 700,
          color: '#d4af37',
          textTransform: 'uppercase',
          letterSpacing: '0.15em',
          animation: 'fwTitleReveal 0.6s 0.5s ease both',
          opacity: 0,
          animationFillMode: 'forwards',
          marginBottom: '32px',
          textAlign: 'center',
        }}>
          🎉 Season Finale Winner 🎉
        </div>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {data.winnerPhotoURL ? (
            <img
              src={data.winnerPhotoURL}
              alt={data.winnerName}
              style={{
                width: '140px',
                height: '140px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '4px solid #d4af37',
                boxShadow: '0 0 40px rgba(212,175,55,0.4)',
                animation: 'fwGoldPulse 2s 1s ease infinite',
                marginBottom: '24px',
              }}
            />
          ) : (
            <div style={{
              width: '140px',
              height: '140px',
              borderRadius: '50%',
              backgroundColor: '#1e1e1e',
              border: '4px solid #d4af37',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '56px',
              fontWeight: 700,
              color: '#d4af37',
              boxShadow: '0 0 40px rgba(212,175,55,0.4)',
              animation: 'fwGoldPulse 2s 1s ease infinite',
              marginBottom: '24px',
            }}>
              {data.winnerName?.charAt(0) || '?'}
            </div>
          )}
        </div>

        <div style={{
          fontSize: '42px',
          fontWeight: 700,
          color: '#ffffff',
          letterSpacing: '-0.03em',
          textAlign: 'center',
          animation: 'fwNameReveal 0.8s 0.9s cubic-bezier(0.34,1.56,0.64,1) both',
          opacity: 0,
          animationFillMode: 'forwards',
          marginBottom: '12px',
        }}>
          {data.winnerName}
        </div>

        <div style={{
          fontSize: '18px',
          fontWeight: 600,
          color: '#d4af37',
          textAlign: 'center',
          marginBottom: '8px',
          animation: 'fwTitleReveal 0.6s 1.3s ease both',
          opacity: 0,
          animationFillMode: 'forwards',
        }}>
          {data.winnerNetGross} strokes net
        </div>

        <div style={{
          fontSize: '14px',
          color: '#6b7280',
          textAlign: 'center',
          marginBottom: '40px',
          animation: 'fwTitleReveal 0.6s 1.5s ease both',
          opacity: 0,
          animationFillMode: 'forwards',
        }}>
          {data.eventName}
        </div>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button
            onClick={onClose}
            style={{
              padding: '16px 32px',
              backgroundColor: '#d4af37',
              color: '#0f0f0f',
              border: 'none',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: 700,
              cursor: 'pointer',
              animation: 'fwTitleReveal 0.6s 1.8s ease both',
              opacity: 0,
              animationFillMode: 'forwards',
            }}
          >
            🏌️ Congratulations {data.winnerName}!
          </button>
        </div>
      </div>
    </div>
  );
}

export default FinaleWinnerPopup;
